import store from '@/store'

export const supportedLocale = [
  {
    code: 'ka',
    base: '',
    flag: 'ge',
    name: 'ქართული' //,
    // translations: '/translations/fr.json'
  }, {
    code: 'en',
    base: 'en',
    flag: 'us',
    name: 'English' //,
    // translations: '/translations/en.json'
  }
]

const loadedLanguages = []
const localization = {
  get currentLocale () {
    return store.getters.locale
  },
  getLocale (locale = 'ka') {
    return supportedLocale.find(loc => loc.code === locale)
  },
  loadLocaleMessagesAsync (locale) {
    if (loadedLanguages.length > 0 && window.vue.$i18n.locale === locale) {
      return Promise.resolve(locale)
    }
    const getLocale = this.getLocale(locale)
    store.dispatch('setLocale', getLocale)
    // If the language was already loaded
    if (loadedLanguages.includes(locale)) {
      window.vue.$i18n.locale = locale
      return Promise.resolve(locale)
    }

    // If the language hasn't been loaded yet
    return import(
      /* webpackChunkName: "locale/locale-[request]" */ 
      '@/locales/' + locale + '.js'
    ).then(messages => {
      // console.log('messages', messages)
      window.vue.$i18n.setLocaleMessage(locale, messages.default)
      loadedLanguages.push(locale)
      window.vue.$i18n.locale = locale
      return Promise.resolve(locale)
    })
  },
  get i18Param () {
    return this.currentLocale.base !== '' ? { locale: this.currentLocale.base } : {}
  },
  i18nRoute (to) {
    const { locale, ...noLocale } = to.params ?? { locale: null }
    return {
      ...to,
      params: {
        ...this.i18Param,
        ...noLocale
      }
    }
  }
}

export {
  localization
}
